<section>
    <header>
      <h2>Annotations</h2>
      <div class="controls">
        <img src="/assets/img/mobile/mb-arrow-{{ expanded() ? 'down' : 'up' }}.svg" alt="arrow up"
          (click)="toggleBottomsheetHeight()" />
        <!-- <img
          style="margin-left: 12px;"
          src="/assets/img/mobile/mb-close.svg"
          alt="close icon"
          (click)="closeBottomSheet()"
        /> -->
      </div>
    </header>
    <div style="padding: 12px;">
        @if(csvAmData()){
        <div class="legend-title">AlphaMissense Pathogenicity</div>
        }
        <div class="modelInfo">
            @if(csvAmData()){
            <div class="confidenceWrapper">
                @for(alpha of alphamissenseLegends; track alpha; let i = $index;) {
                <div class="column legendRow">
                    <span class="legendColor" [ngStyle]="alpha.style">&nbsp;</span><span class="legendlabel">{{
                        alpha.label }}</span>
                </div>
                }
            </div>
            }
            @if(csvAmData()){
            <div class="column legendDesc">
                The displayed colour represents the average AlphaMissense pathogenicity score for all possible amino
                acid substitutions at that position.
            </div>
            }
            @if(!csvAmData()){
            <div class="legendDesc">
                <span class="desc-title">No annotation information available</span><br />
                <span> 
                    This protein does not currently have any annotations identified. Annotations will appear here if
                    data becomes available in future updates.
                </span>
            </div>
            }
        </div>
    </div>
</section>